import styled from 'styled-components';

export const Wrapper = styled.div`
  padding: 1rem;
  display: flex;
  justify-content: center;
  background-color: #f9f9f9;
`;

export const Card = styled.div`
  background: white;
  padding: ${({ isPadding = true }) => (isPadding ? '2rem' : '0')};
  width: 100%;
  max-width: ${({ isFixedWidth }) => (isFixedWidth ? '700px' : '100%')};
  border-radius: 16px;
  box-shadow: ${({ isPadding = true }) => (isPadding ? '0 4px 16px rgba(0, 0, 0, 0.1)' : '0')};
  position: relative; /* ✅ Required for absolute positioning inside */
`;

export const Header = styled.h2`
  font-size: 1.8rem;
  margin-bottom: 0px;
  color: #333;
`;

export const Divider = styled.hr`
  margin: 0px;
  border: none;
  border-top: 1px solid #eee;
`;

export const LoaderContainer = styled.div`
  text-align: center;
  font-size: 1.2rem;
`;

export const FormGroup = styled.div`
  margin-bottom: 1rem;
`;

export const Label = styled.label`
  display: block;
  margin-bottom: 5px;
  font-weight: 600;
  color: #555;
`;

export const Input = styled.input`
  width: 100%;
  padding: 0.75rem;
  border: 1px solid #ccc;
  border-radius: 8px;
  font-size: 1rem;
`;

export const Textarea = styled.textarea`
  width: 100%;
  padding: 0.75rem;
  border: 1px solid #ccc;
  border-radius: 8px;
  font-size: 1rem;
  resize: vertical;
`;

export const SubmitButton = styled.button`
  padding: 0.75rem 1.5rem;
  background-color: #007bff;
  border: none;
  width: 100%;
  color: white;
  font-size: 1rem;
  border-radius: 8px;
  cursor: pointer;

  &:hover {
    background-color: #0056b3;
  }
`;



export const SectionTitle = styled.h2`
  font-size: 2.5rem;
  font-weight: bold;
  text-align: center;
  color: #333;
  margin-top:0px ;
  position: relative;
  &::after {
    content: '';
    width: 80px;
    height: 4px;
    background: #007bff;
    display: block;
    margin: 10px auto 0;
  }
`;

export const StorySection = styled.div`
  text-align: center;
  margin-bottom: 20px;
`;

export const StoryImage = styled.img`
  width: 100%;
  max-width: 550px;
  border-radius: 12px;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease;
  &:hover {
    transform: scale(1.05);
  }
`;

export const StoryText = styled.p`
  font-size: 1rem;
  color: #555;
  text-align:start;
  line-height: 1.6;
  white-space: pre-wrap;
  word-wrap: break-word;
  word-break: break-word;  // 🔥 this is the key line
`;




export const ImagePreview = styled.img`
  max-width: 100%;
  height: auto;
  margin-top: 1rem;
  border-radius: 8px;
`;

export const Title = styled.h3`
  font-size: 1.5rem;
  margin-bottom: 0.5rem;
  color: #222;
`;

export const Description = styled.p`
  font-size: 1rem;
  color: #444;
  line-height: 1.6;
`;


export const EditButton = styled.button`
  position: absolute;
  top: 16px;
  right: 16px;
  background-color: #007bff;
  color: white;
  border: none;
  padding: 10px 40px;
  border-radius: 6px;
  font-size: 0.875rem;
  cursor: pointer;

  &:hover {
    background-color: #0056b3;
  }
`;
